import { app } from '../vue/app.js'

export default {
  props: {
    welcomeDwLimit: {
      type: Number,
      default: 0
    },

    customerTags: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isSticky: false
    }
  },
  computed: {
    cart () {
      return app.cart
    },

    finalCartPrice () {
      /* eslint-disable camelcase */
      return this.cart.items ? this.cart.items.reduce((a, { final_line_price }) => a + final_line_price, 0) : null
    },

    purchasedWelcomeDwQuantities () {
      if (!this.customerTags) return {}

      const quantities = {}
      const tags = this.customerTags.split(',')

      tags.forEach(tag => {
        const trimmedTag = tag.trim()
        if (trimmedTag.startsWith('welcome-purchase-')) {
          const match = trimmedTag.match(/welcome-purchase-.+-(.+?):(\d+)$/)
          if (match) {
            const sku = match[1]
            const qty = parseInt(match[2]) || 0
            quantities[sku] = (quantities[sku] || 0) + qty
          }
        }
      })

      return quantities
    }
  },

  mounted () {
    const checkCartSummary = setInterval(() => {
      const stickyElement = document.querySelector('.cart__summary')

      if (stickyElement) {
        clearInterval(checkCartSummary)
        this.detectStickyCartSummary()
      }
    }, 100)

    addEventListener('scroll', () => {
      this.detectStickyCartSummary()
    })
  },

  methods: {
    updateQuantity (...args) {
      app.updateQuantity(...args)
    },
    minusQuantity (...args) {
      app.minusQuantity(...args)
    },
    addQuantity (...args) {
      app.addQuantity(...args)
    },
    isWelcomeDwLimitExceeded (item) {
      if (!item.properties?._is_welcome_product || !this.welcomeDwLimit) return false

      const isNotLoggedIn = !window.liquid_is_logged_in
      if (isNotLoggedIn) return true

      const currentSku = item.sku
      const rawPurchasedQuantity = this.purchasedWelcomeDwQuantities[currentSku] || 0

      const currentCartQuantity = this.cart?.items
        ?.filter(cartItem => cartItem.sku === currentSku)
        ?.reduce((total, cartItem) => total + cartItem.quantity, 0) || 0

      const bottlesPerCaseTag = item.tags?.find(tag => tag.toLowerCase().includes('bottles_per_case|'))
      const bottlesPerCase = bottlesPerCaseTag ? parseInt(bottlesPerCaseTag.split('|').pop()) : null

      const purchasedStacks = bottlesPerCase ? Math.ceil(rawPurchasedQuantity / bottlesPerCase) : rawPurchasedQuantity
      const currentStacks = bottlesPerCase ? Math.ceil(currentCartQuantity / bottlesPerCase) : currentCartQuantity
      const addingStacks = bottlesPerCase ? Math.ceil(1 / bottlesPerCase) : 1

      const totalStacks = purchasedStacks + currentStacks + addingStacks

      console.log('WelcomeDW Limit Exceeded Debug:', {
        sku: currentSku,
        purchasedQuantity: rawPurchasedQuantity,
        currentCartQuantity,
        bottlesPerCase,
        purchasedStacks,
        currentStacks,
        addingStacks,
        welcomeDwLimit: this.welcomeDwLimit,
        isNotLoggedIn
      }
      )

      return totalStacks > this.welcomeDwLimit
    },
    detectStickyCartSummary () {
      const stickyElement = document.querySelector('.cart__summary')
      const stickyElementBottomPosition = stickyElement?.getBoundingClientRect().bottom
      const windowInnerHeight = window.innerHeight

      this.isSticky = stickyElementBottomPosition === windowInnerHeight
    }
  }
}
